import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { ColonToEmojiPipe } from 'src/pipes/colonToEmoji.pipe';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminAiTesterRoutingModule } from './admin-ai-tester-routing.module';
import { AdminAiTesterComponent } from './admin-ai-tester.component';
import { AgentComparisonTesterComponent } from './agent-comparison-tester/agent-comparison-tester.component';
import { SingleAgentTesterComponent } from './single-agent-tester/single-agent-tester.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedPipesModule,
    AvatarModule,
    AdminAiTesterRoutingModule,
    NgxTippyModule,
    ColonToEmojiPipe,
  ],
  declarations: [AdminAiTesterComponent, SingleAgentTesterComponent, AgentComparisonTesterComponent],
  exports: [AdminAiTesterComponent],
})
export class AdminAiTesterModule {}
